import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { Theme } from './service-models/theme';

@Injectable({
  providedIn: 'root'
})
export class AtsService {
  apiGatewayUrl: string;

  constructor(private http: HttpClient) {
    this.apiGatewayUrl = environment().apiGatewayUrl;
  }

  getTheme(subBrandIdentifier: string): Observable<Theme> {
    let params = new HttpParams();
    if (subBrandIdentifier) {
      params = params.append('subBrandIdentifier', subBrandIdentifier);
    }

    return this.http.get<Theme>(`${this.apiGatewayUrl}theme`, { params });
  }
}
